import React from 'react';

import type { SVGProps } from 'react';

const WeightScaleIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3.89986"
        y="3.90035"
        width="16.2"
        height="16.335"
        rx="2.97"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.08"
      />
      <path
        d="M15.5404 16.2767C15.4685 16.864 14.8474 17.0713 14.5458 17.1016C14.0654 17.1175 13.4844 16.698 13.6827 15.8238C13.778 15.4038 13.7096 14.7365 13.5403 14.0659C13.3307 13.2356 13.1945 12.2144 13.9089 11.7423C14.9884 11.0291 16.261 12.0902 16.0955 12.9955C15.9361 13.8677 15.6123 15.6894 15.5404 16.2767Z"
        stroke="#F4F4FC"
        strokeWidth="0.6912"
      />
      <path
        d="M8.50695 16.2767C8.57887 16.864 9.20001 17.0713 9.50159 17.1016C9.98195 17.1175 10.563 16.698 10.3646 15.8238C10.2694 15.4038 10.3377 14.7365 10.5071 14.0659C10.7167 13.2356 10.8529 12.2144 10.1384 11.7423C9.05895 11.0291 7.78636 12.0902 7.95185 12.9955C8.11129 13.8677 8.43503 15.6894 8.50695 16.2767Z"
        stroke="#F4F4FC"
        strokeWidth="0.6912"
      />
      <mask id="path-4-inside-1_17340_2765" fill="white">
        <rect
          x="8.09717"
          y="6.58594"
          width="8.5248"
          height="3.1104"
          rx="0.3456"
        />
      </mask>
      <rect
        x="8.09717"
        y="6.58594"
        width="8.5248"
        height="3.1104"
        rx="0.3456"
        fill="#F4F4FC"
        stroke="#F4F4FC"
        strokeWidth="1.11282"
        mask="url(#path-4-inside-1_17340_2765)"
      />
      <rect
        x="4.74205"
        y="4.74303"
        width="14.5152"
        height="14.6304"
        rx="2.304"
        stroke="#F4F4FC"
        strokeWidth="0.9216"
      />
    </svg>
  );
};

export default WeightScaleIcon;
